export type ToolCallSeverity = 'success' | 'warning' | 'error';

// `status` is 'error' when the call raised or was never sent; a 4xx/5xx response resolves as 'success'.
export type ToolCallSeverityInput = {
  status: 'success' | 'error';
  http_status_code: number | null;
};

export const getToolCallSeverity = ({
  status,
  http_status_code,
}: ToolCallSeverityInput): ToolCallSeverity => {
  if (status === 'error') return 'error';
  if (http_status_code == null) return 'success';
  if (http_status_code >= 500) return 'error';
  if (http_status_code >= 400) return 'warning';
  if (http_status_code >= 200) return 'success';
  return 'warning';
};
